// extracted by mini-css-extract-plugin
export default {"root":"O5Y69E1u","item":"TYXN9rO9","itemActive":"cg7pRA4s","itemAvatar":"QfbdBWlU","itemButton":"kkva74Vl","itemIcon":"DAa7arWE","menu":"TzEdUZUl","menuIcon":"XMPQdzt5"};